const JUMP_CONDITION_TYPES = {
  HAS_ROLE: 'hasRole',
  DOES_NOT_HAVE_ROLE: 'doesNotHaveRole',
  HAS_CLAIM: 'hasClaim',
  DOES_NOT_HAVE_CLAIM: 'doesNotHaveClaim',
  HAS_PRODUCT_ID: 'hasProductId',
  DOES_NOT_HAVE_PRODUCT_ID: 'doesNotHaveProductId',
  HAS_ACTIVE_SUBSCRIPTION: 'hasActiveSubscription',
  DOES_NOT_ACTIVE_SUBSCRIPTION: 'doesNotHaveActiveSubscription',
  LOGGED_IN: 'loggedIn',
  LOGGED_OUT: 'loggedOut',
  DATASOURCE: 'datasource',
  JSON: 'json',
  HAS_DOCUMENTS: 'hasDocuments',
  CODE_RETURNS_TRUE: 'codeReturnsTrue',
  HAS_UNIQUE_EMAIL: 'emailUnique'
};

export default JUMP_CONDITION_TYPES;
